import {Component, inject} from "@angular/core";
import {ComponentWithModal, ModalService} from "@kwsoft/otcx-core";
import {SearchService} from "../search/search.service";

@Component({
    selector: "otcx-layout-header",
    templateUrl: "./layout-header.component.html",
    styleUrls: ["./layout-header.component.scss"],
    standalone: false
})
export class LayoutHeaderComponent extends ComponentWithModal {
    private readonly searchService = inject(SearchService);

    constructor() {
        super("searchModal", inject(ModalService));
    }

    get searchTerm(): string {
        return this.searchService.searchTerm;
    }
}
